import { render, staticRenderFns } from "./emailSetting.vue?vue&type=template&id=1dfd8ec1&scoped=true"
import script from "./emailSetting.vue?vue&type=script&lang=js"
export * from "./emailSetting.vue?vue&type=script&lang=js"
import style0 from "./emailSetting.vue?vue&type=style&index=0&id=1dfd8ec1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd8ec1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dfd8ec1')) {
      api.createRecord('1dfd8ec1', component.options)
    } else {
      api.reload('1dfd8ec1', component.options)
    }
    module.hot.accept("./emailSetting.vue?vue&type=template&id=1dfd8ec1&scoped=true", function () {
      api.rerender('1dfd8ec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/emailSetting.vue"
export default component.exports